module.exports = __webpack_public_path__ + "img/gamification-250.6c540a32.png";